export default __webpack_public_path__ + "static/desktop_6-d6f2712862c51f069b550f448a9115f2.webp";